import { CommonAPI } from "../Client";

export const createSubscriptionAPI = (payload) => {
  return CommonAPI.post("/tenant/subscription", payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const changeSubscriptionPlanAPI = (payload) => {
  return CommonAPI.put("/tenant/subscription/change", payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const cancelSubscriptionAPI = () => {
  return CommonAPI.post("/tenant/cancel/subscription")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const cancelUpcomingPlanAPI = () => {
  return CommonAPI.put("/tenant/subscription/change/cancel")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const updatePaymentMethodAPI = () => {
  return CommonAPI.put("/tenant/update/payment-method")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getCurrentSubscriptionInvoiceAPI = (payload) => {
  return CommonAPI.get(
    `/tenant/subscription/invoice?size=${payload?.size || 5}&page=${payload?.page || 0}`
  )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const getCurrentSubscriptionAPI = () => {
  return CommonAPI.get("/tenant/subscription")
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const subscriptionPaymentSuccessAPI = (payload) => {
  return CommonAPI.put(
    `/update/tenant/subscription/status?status=${payload?.status}`
  )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};


export const subscriptionVerifyPaymentAPI = () => {
  return CommonAPI.get(
    `/verify/tenant/payment`
  )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const createSubscriptionAddonAPI = (payload) => {
  return CommonAPI.post("/tenant/magic/addon", payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const verifySubscriptionAddonPaymentAPI = (payload) => {
  return CommonAPI.post("/tenant/verify/addon/payment", payload)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

